import { useBubbleTextMenuStates } from '@/components/tiptap/hooks/useBubbleTextMenuStates';
import { canOfferSectionConversion } from '@/components/tiptap/shared/convert-selection-to-section';
import { selectFullTextToolbarFormatStates } from '@/components/tiptap/utils/textToolbarMenuEditorState';
import { type Editor } from '@tiptap/react';

export const selectFormatStates = (ctx: { editor: Editor }) => ({
  ...selectFullTextToolbarFormatStates(ctx),
  canConvertToSection: canOfferSectionConversion(ctx.editor.state),
});

export const useTextMenuStates = ({
  editor,
  selector,
}: {
  editor: Editor;
  selector: string;
}) =>
  useBubbleTextMenuStates({
    editor,
    selector,
    selectFormatStates,
  });
